import { TaskStatusType } from '@/types/admin/tasks';

/**
 * Task status constants to avoid string literals and improve type safety
 */
export const TASK_STATUSES = {
  INCOMING: 'incoming',
  PENDING: 'pending', 
  TODO: 'todo',
  IN_PROGRESS: 'inProgress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const satisfies Record<string, TaskStatusType>;

/**
 * Type-safe helper to get task status
 */
export const getTaskStatus = (status: keyof typeof TASK_STATUSES): TaskStatusType => {
  return TASK_STATUSES[status];
};
